import "../style.css";
import { useTranslation } from "react-i18next";
import moment from "moment";
import ReactTooltip from "react-tooltip";

/* =========================
   Helpers (logic unchanged)
========================= */

const getVehicleKey = (name) => name.replace(/ /g, ".");

const getTotal = (arr, key) =>
    arr.reduce((total, item) => total + item[key], 0);

const getTransferType = (cart, t) => {
    if (cart.bookingType === "byTheHour") {
        return t("TypeOfTransfer.ByTheHour");
    }
    if (cart.isAirportTransfer) {
        return t("TypeOfTransfer.AirportTransfer");
    }
    return t("TypeOfTransfer.SpecifiedDestination");
};

const dateFormat = {
    EN: "MMMM Do, YYYY (ddd)",
    JP: "YYYY年MM月DD日（ddd）",
};

const VehicleInformation = ({
    cart,
    lang,
    className = "mt-4 mt-sm-0",
}) => {
    const { t } = useTranslation();
    const isMultiple = cart.bookingInfo.length > 1;

    return (
        <div
            className={`tw:!rounded ${className} ${isMultiple ? "bg-gold-light-100 tw:!p-4" : ""
                }`}
        >
            {cart.bookingInfo.map((item, index) => {
                const vehicleKey = getVehicleKey(item.vehicleTypeName);

                return (
                    <div
                        key={index}
                        className={`tw:relative tw:flex tw:flex-col tw:min-w-0 tw:bg-white tw:bg-clip-border tw:border tw:border-[rgba(0,0,0,0.125)] tw:rounded-[0.3rem] tw:!relative ${index < cart.bookingInfo.length - 1
                            ? "tw:!mb-4"
                            : "tw:!mb-0"
                            }`}
                    >
                        {isMultiple && (
                            <div
                                className="noto tw:!absolute tw:!flex tw:!items-center tw:!justify-center"
                                style={{
                                    width: "36px",
                                    height: "36px",
                                    borderRadius: "100%",
                                    fontSize: "16px",
                                    color: "white",
                                    backgroundColor: "#DBBE78",
                                    top: "-10px",
                                    left: "-10px",
                                }}
                            >
                                {index + 1}
                            </div>
                        )}

                        <div className="tw:flex-1 tw:p-4 tw:!mt-3 tw:!p-6">
                            <div className="tw:!grid tw:!grid-cols-1 tw:!gap-4">
                                {/* Transfer Type */}
                                <div className="tw:!flex tw:!items-center tw:!justify-center">
                                    <div className="tw:inline-block tw:py-[0.35em] tw:px-[0.65em] tw:text-[0.75em] tw:font-semibold tw:leading-none tw:text-white tw:text-center tw:whitespace-nowrap tw:align-baseline tw:rounded-[0.375rem] tw:[font-family:var(--font-sans-primary)] tw:rounded-[50rem] tw:bg-[#F9F9F9] tw:!py-2 tw:!w-full tw:!text-[#4A4A4A] tw:!font-[400] tw:!text-[13px] tw:!text-center">
                                        {getTransferType(cart, t)}
                                    </div>
                                </div>

                                {/* Booking Details */}
                                <div className="tw:!flex tw:!flex-col">
                                    {/* Vehicle Image */}
                                    <div>
                                        <img
                                            src={item.images.png}
                                            className="tw:w-full tw:rounded-t-[0.3rem] tw:!px-10 tw:!h-full"
                                            alt=""
                                        />
                                    </div>

                                    {/* Vehicle Info */}
                                    <div className="tw:!flex tw:!flex-col">
                                        <div className="tw:bg-transparent tw:border-0 tw:py-2 tw:px-4 tw:mb-0 tw:[font-family:var(--font-sans-primary)] tw:font-bold tw:tracking-[3px] tw:text-[0.5rem]! tw:uppercase tw:!pt-3 tw:!pb-0 tw:!px-0">
                                            {t(`${vehicleKey}.Tag`)}
                                        </div>

                                        <div className="tw:font-libre-caslon-display tw:text-[26px] tw:leading-[40px] tw:!font-[400]">
                                            {t(vehicleKey)}
                                        </div>
                                    </div>

                                    {
                                        item.vehicleTypeName === "Toyota Alphard" && (
                                            <div className="tw:!flex tw:!flex-col">
                                                <div className="tw:!pt-3 tw:!pb-0 tw:!px-0">
                                                    <p className="tw:!m-0 tw:!text-[12px] tw:!font-[400] tw:!text-[#8D8D8D]">
                                                        {t("BookingConfirmation.Car.AlphardNote")}
                                                    </p>
                                                </div>
                                            </div>
                                        )
                                    }

                                    <hr className="tw:!border-[#E2E0E0]" />

                                    {/* Detail List */}
                                    <div className="">
                                        {cart.bookingType === "byTheHour" && (
                                            <div className="tw:flex tw:flex-wrap tw:!mb-1">
                                                <p className="tw:!m-0 tw:!w-1/2 tw:text-[13px] tw:font-[400] tw:!text-[#7C7B7B]">
                                                    {t("BookingConfirmation.Car.TravelArea.Title")}
                                                </p>
                                                <p className="tw:!m-0 tw:!w-1/2 tw:text-[13px] tw:font-[400] tw:!text-[#282828]">
                                                    {t(`BookingConfirmation.Car.TravelArea.${cart?.bookingInfo[0]?.travelArea}`)}
                                                </p>
                                            </div>
                                        )}


                                        <div className="tw:flex tw:flex-wrap tw:!mb-1">
                                            <p className="tw:!m-0 tw:!w-1/2 tw:text-[13px] tw:font-[400] tw:!text-[#7C7B7B]">
                                                {t("BookingConfirmation.Car.NumberOfPassanger")}
                                            </p>
                                            <p className="tw:!m-0 tw:!w-1/2 tw:text-[13px] tw:font-[400] tw:!text-[#282828]">
                                                {getTotal(item.pax, "paxcount")}
                                            </p>
                                        </div>


                                        <div className="tw:flex tw:flex-wrap tw:!mb-1">
                                            <p className="tw:!m-0 tw:!w-1/2 tw:text-[13px] tw:font-[400] tw:!text-[#7C7B7B]">
                                                {t("BookingConfirmation.Car.NumberOfLuggage")}
                                            </p>
                                            <p className="tw:!m-0 tw:!w-1/2 tw:text-[13px] tw:font-[400] tw:!text-[#282828]">
                                                {getTotal(item.luggage, "luggagecount")}
                                            </p>
                                        </div>


                                        <div className="tw:flex tw:flex-wrap tw:!mb-1">
                                            <p className="tw:!m-0 tw:!w-1/2 tw:text-[13px] tw:font-[400] tw:!text-[#7C7B7B]">
                                                {t("BookingConfirmation.Car.TravelDate")}
                                            </p>
                                            <p className="tw:!m-0 tw:!w-1/2 tw:text-[13px] tw:font-[400] tw:!text-[#282828]">
                                                {moment(cart.pickupDateTime)
                                                    .utc()
                                                    .format(dateFormat[lang])}
                                            </p>
                                        </div>


                                        <div className="tw:flex tw:flex-wrap tw:!mb-1">
                                            <p className="tw:!m-0 tw:!w-1/2 tw:text-[13px] tw:font-[400] tw:!text-[#7C7B7B]">
                                                {t("BookingConfirmation.Car.PickupTime")}
                                            </p>
                                            <p className="tw:!m-0 tw:!w-1/2 tw:text-[13px] tw:font-[400] tw:!text-[#282828]">
                                                {cart.pickupTime}
                                            </p>
                                        </div>


                                        <div className="tw:flex tw:flex-wrap tw:!mb-1">
                                            <p className="tw:!m-0 tw:!w-1/2 tw:text-[13px] tw:font-[400] tw:!text-[#7C7B7B]">
                                                {t("BookingConfirmation.Car.DropoffTime")}
                                            </p>
                                            <p className="tw:!m-0 tw:!w-1/2 tw:text-[13px] tw:font-[400] tw:!text-[#282828]">
                                                {moment.utc(cart.customerDropoffDateTime).format("HH:mm")}
                                            </p>
                                        </div>

                                        {cart.bookingType === "byTheHour" && (
                                            <>
                                                <div className="tw:flex tw:flex-wrap tw:!mb-1">
                                                    <p className="tw:!m-0 tw:!w-1/2 tw:text-[13px] tw:font-[400] tw:!text-[#7C7B7B]">
                                                        {t("BookingConfirmation.Car.UsageDuration")}
                                                    </p>
                                                    <p className="tw:!m-0 tw:!w-1/2 tw:text-[13px] tw:font-[400] tw:!text-[#282828]">
                                                        {lang === "EN"
                                                            ? cart.usageDuration + " Hours"
                                                            : cart.usageDuration + "時間"}{" "}
                                                        &nbsp;
                                                        <i
                                                            data-tip
                                                            data-for="usageDuration"
                                                            className="fas fa-info-circle tw:text-[#DBBE78]!"
                                                        ></i>
                                                        <ReactTooltip
                                                            id="usageDuration"
                                                            backgroundColor="#F6EEDC"
                                                            textColor="#4E4E4E"
                                                            place="top"
                                                            effect="solid"
                                                            multiline={true}
                                                            className="fixed-size-tooltip"
                                                        >
                                                            <span>
                                                                <p className={"tw:m-0"} dangerouslySetInnerHTML={{
                                                                    __html: t("usageDurationTooltip"),
                                                                }}>
                                                                </p>
                                                            </span>
                                                        </ReactTooltip>
                                                    </p>
                                                </div>
                                                <div className="tw:flex tw:flex-wrap tw:!mb-1">
                                                    <p className="tw:!m-0 tw:!w-1/2 tw:text-[13px] tw:font-[400] tw:!text-[#7C7B7B]">
                                                        {t("BookingConfirmation.Car.BilledDuration")}
                                                    </p>
                                                    <p className="tw:!m-0 tw:!w-1/2 tw:text-[13px] tw:font-[400] tw:!text-[#282828]">
                                                        {lang === "EN"
                                                            ? cart.billedDuration + " Hours"
                                                            : cart.billedDuration + "時間"}{" "}
                                                        &nbsp;
                                                        <i
                                                            data-tip
                                                            data-for="billedDuration"
                                                            className="fas fa-info-circle tw:text-[#DBBE78]!"
                                                        ></i>
                                                        <ReactTooltip
                                                            id="billedDuration"
                                                            backgroundColor="#F6EEDC"
                                                            textColor="#4E4E4E"
                                                            place="top"
                                                            effect="solid"
                                                            multiline={true}
                                                            className="fixed-size-tooltip"
                                                        >
                                                            <span>
                                                                <p className="tw:m-0" dangerouslySetInnerHTML={{
                                                                    __html: t(
                                                                        "billedDurationTooltip"
                                                                    ),
                                                                }}></p>
                                                            </span>
                                                        </ReactTooltip>
                                                    </p>
                                                </div>
                                            </>
                                        )}


                                        <div className="tw:flex tw:flex-wrap tw:!mb-1 tw:!items-start">
                                            <p className="tw:!m-0 tw:!w-1/2 tw:text-[13px] tw:font-[400] tw:!text-[#7C7B7B]">
                                                {t("BookingConfirmation.Car.PickupLocation")}
                                            </p>
                                            <p className="tw:!m-0 tw:!w-1/2 tw:text-[13px] tw:font-[400] tw:!text-[#282828]">
                                                {cart.pickupLocation.label}
                                            </p>
                                        </div>


                                        <div className="tw:flex tw:flex-wrap tw:!mb-1 tw:!items-start">
                                            <p className="tw:!m-0 tw:!w-1/2 tw:text-[13px] tw:font-[400] tw:!text-[#7C7B7B]">
                                                {t("BookingConfirmation.Car.DropoffLocation")}
                                            </p>
                                            <p className="tw:!m-0 tw:!w-1/2 tw:text-[13px] tw:font-[400] tw:!text-[#282828]">
                                                {cart.destinations.map((itm, ind) => (
                                                    <span key={ind} className="tw:!block">
                                                        {cart.destinations.length > 1 && `(${ind + 1}) `}
                                                        {itm.label}
                                                    </span>
                                                ))}
                                            </p>
                                        </div>
                                    </div>


                                </div>
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default VehicleInformation;
